export const mapObjectToArray = (obj) => (Object.keys(obj).map((k) => obj[k]));

export default mapObjectToArray;
